
  import { NAVIGATION } from '~/constants/navigation';
  import { mapGetters } from 'vuex';

  export default {
    data () {
      return {
        menuOpen: false,
        searchTerm: null,
        stillHoveringNavLink: false,
        currentNavMenu: {},
        navSlot: '',
        userSlot: '',
        navigation: NAVIGATION
      };
    },
    computed: {
      ...mapGetters({
        meta: 'utils/getMeta',
        user: 'user/get'
      }),
      articles () {
        const articles = this.$store.getters['blog/getList'];
        return articles.slice(0, 4);
      },
      disableNavMenu () {
        return ((this.meta && this.meta.disableNav) || this.$route.path.includes('results'));
      },
      profileImage () {
        return this.user.profile_image;
      }
    },
    methods: {
      categoryTitle (category) {
        if (category === 'energy') {
          return 'Gas & Electricity';
        } else {
          return category;
        }
      },
      hideDynamicMenu () {
        this.stillHoveringNavLink = false;
        setTimeout(() => {
          if (this.stillHoveringNavLink === false) {
            this.menuOpen = false;
          }
        }, 50);
      },
      hoveringMenu () {
        this.stillHoveringNavLink = true;
      },
      newProductBadge (key) {
        if (key === 'ci') {
          return true;
        } else if (key === 'hi') {
          return true;
        } else {
          return false;
        }
      },
      resetRenderSlots () {
        this.navSlot = '';
        this.userSlot = '';
      },
      search: function () {
        if (this.searchTerm && this.searchTerm.length > 3) {
          window.location.href = `/search/?q=${this.searchTerm}`;
        }
      },
      setCurrentItem (currentItem) {
        if (currentItem !== null) {
          this.currentNavMenu = currentItem;
        }
      },
      showDynamicNav (e, slotToRender) {
        this.resetRenderSlots();

        if (slotToRender === 'navlinks') {
          this.navSlot = 'content';
        } else if (slotToRender === 'user') {
          this.userSlot = 'content';
          this.currentNavMenu = { category: 'user' };
        }

        this.menuOpen = true;
        this.stillHoveringNavLink = true;
      }
    }
  };
